import {useParams} from 'react-router-dom';
import {ILearningPathIdParam} from 'models/resources';

export const useLearningPathIdParam = () => {
  const urlParams = useParams<ILearningPathIdParam>();

  return {learningPathId: urlParams?.id};
};
